import React, { useState, useEffect } from 'react';
import { OutlinedInput, FormControl, InputLabel, InputAdornment, IconButton } from '@material-ui/core';
import { Search as SearchIcon } from '@material-ui/icons';
import { SearchBoxProps } from '../../types';

const SearchBox: React.FC<SearchBoxProps> = ({
  label,
  onChange,
  onSubmit,
  startValue,
  searchButtonAria,
}: SearchBoxProps) => {
  const [searchText, setSearchText] = useState(startValue);
  const [hasFocus, setHasFocus] = useState(false);
  const shrinkLabel = hasFocus || searchText !== '' ? true : false;
  useEffect(() => setSearchText(startValue), [startValue]);

  const handleSearchBoxOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      onChange(event);
    }
    setSearchText(event.currentTarget.value);
  };

  const handleSearchBoxKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      onSubmit(searchText);
    }
  };
  return (
    <FormControl fullWidth variant="outlined">
      <InputLabel htmlFor="search-box-input" shrink={shrinkLabel} sx={{ pl: shrinkLabel ? 0 : 8 }}>
        {label}
      </InputLabel>
      <OutlinedInput
        id="search-box-input"
        label={label}
        value={searchText}
        onChange={handleSearchBoxOnChange}
        onKeyPress={handleSearchBoxKeyPress}
        notched={shrinkLabel}
        onFocus={() => setHasFocus(true)}
        onBlur={() => setHasFocus(false)}
        startAdornment={
          <InputAdornment position="end">
            <IconButton aria-label={searchButtonAria} edge="start" onClick={() => onSubmit(searchText)}>
              <SearchIcon />
            </IconButton>
          </InputAdornment>
        }
        sx={{
          backgroundColor: '#fff',
        }}
      />
    </FormControl>
  );
};

export default SearchBox;
